import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core"
import { Store } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Window } from "@models/window";
import { CompleterService, CompleterData, CompleterItem } from "ng2-completer";
import { Day } from "@models/day";
import { ConstantsStore } from "@store/constants";
import { Observable } from "rxjs/Observable";
import * as moment from "moment";

@Component({
  selector: 'window-form',
  templateUrl: './window-form.pug',
})
export class WindowFormComponent implements OnInit {

  @Input() public window: Window
  @Output() public submitted: EventEmitter<Window> = new EventEmitter<Window>()
  @Output() public closed: EventEmitter<Window> = new EventEmitter<Window>()

  public constantsStore: Observable<ConstantsStore>

  public daySearchStr: string
  public dayCompleter: CompleterData
  public days: Day[]

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
  ) {}

  ngOnInit() {
    this.constantsStore = this.store.select("constantsReducer")
    this.constantsStore.subscribe((s: ConstantsStore) => {
      this.days = s.constants.days
    })

    this.dayCompleter =
      this.completerService.local(this.days, "name", "name")
  }

  clickedSubmit(e: MouseEvent) {
    e.preventDefault()
    this.submitted.emit(this.window)
  }

  clickedCancel(e: MouseEvent) {
    e.preventDefault()
    this.closed.emit(this.window)
  }

  selectedDay(e: CompleterItem) {
    if (e && e.originalObject) {
      this.window.dayId = (e.originalObject as Day).id
    }
  }

  changedStartTime(timeString: string, window: Window) {
    window.startTime = this.getDateFromTimeString(timeString)
  }

  changedEndTime(timeString: string, window: Window) {
    window.endTime = this.getDateFromTimeString(timeString)
  }

  changedLunchStartTime(timeString: string, window: Window) {
    window.lunchStartTime = this.getDateFromTimeString(timeString)
    window.lunchEndTime = moment(window.lunchStartTime).add(1, "h").toDate()
  }

  getDateFromTimeString(timeString: string): Date {
    const parts = timeString.split(":")
    const mDateTime = moment()
    return mDateTime
      .hour(parseInt(parts[0]))
      .minute(parseInt(parts[1]))
      .second(0)
      .toDate()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/window-form.ts